// extracted by mini-css-extract-plugin
module.exports = {"recipeFAQWrapper":"RecipeFAQ_recipeFAQWrapper__RBkO3"};